import { declareTheme } from "@component-library/themes";

export const useTheme = declareTheme({
  default: {
    container: 'gap-2',
    content: {
      base: 'rounded-md',
      enabled: 'text-neutral-950 bg-neutral-100',
      disabled: 'text-neutral-400 bg-neutral-150'
    },
    wrapper: {
      enabled: 'ring-neutral-300',
      disabled: 'ring-neutral-200'
    },
    focus: true
  },
  editor: {
    container: 'gap-1.5',
    content: {
      base: 'rounded',
      enabled: 'text-neutral-950 bg-white',
      disabled: 'text-neutral-400 bg-neutral-150'
    },
    wrapper: {
      enabled: 'ring-neutral-200',
      disabled: 'ring-neutral-200'
    },
    focus: false
  }
})